import React from 'react';
import { IconProps } from './types';

const Download: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 32 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M5.499 27.229h22.254v3.719h-22.254v-3.719z"
    />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M20.417 16.515v-14.977h-7.479v14.977h-7.056l10.891 9.209 10.98-9.209z"
    />
  </svg>
);

export default Download;
